"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createLightGallery;
const lightgallery_1 = __importDefault(require("lightgallery"));
const thumbnail_1 = __importDefault(require("lightgallery/plugins/thumbnail"));
const video_1 = __importDefault(require("lightgallery/plugins/video"));
const ScrollingState_1 = __importDefault(require("@web/common/ScrollingState"));
function createLightGallery(galleryElement, isDynamic = false, enableDownload = false) {
    return (0, lightgallery_1.default)(galleryElement, {
        licenseKey: 'E10381A9-46F4468E-B977D7D6-7BF306BC',
        allowMediaOverlap: true,
        animateThumb: true,
        download: enableDownload === true,
        dynamic: isDynamic === true,
        mode: 'lg-fade',
        selector: '.gallery-image',
        speed: 150,
        plugins: [thumbnail_1.default, video_1.default],
        zoomFromOrigin: false,
        thumbnail: true,
        thumbHeight: '60px',
        thumbWidth: 90,
        exThumbImage: 'data-thumb',
        mobileSettings: {
            showCloseIcon: true,
        },
        autoplayFirstVideo: true,
        autoplayVideoOnSlide: true,
        gotoNextSlideOnVideoEnd: true,
        youTubePlayerParams: {
            modestbranding: 1,
            showinfo: 0,
            controls: 0,
        },
        preload: 2,
    });
}
const galleries = Array.from(document.querySelectorAll('.light-gallery-container'));
galleries.forEach((gallery) => {
    gallery.addEventListener('lgBeforeOpen', () => {
        ScrollingState_1.default.disableScrolling();
    });
    gallery.addEventListener('lgBeforeClose', () => {
        ScrollingState_1.default.enableScrolling();
    });
    createLightGallery(gallery);
});
